// src/app/redux/reducers/sectionReducer.js

import {
    FETCH_SECTIONS_REQUEST,
    FETCH_SECTIONS_SUCCESS,
    FETCH_SECTIONS_FAIL,
    SAVE_SECTION_REQUEST,
    SAVE_SECTION_SUCCESS,
    SAVE_SECTION_FAIL,
    DELETE_SECTION_REQUEST,
    DELETE_SECTION_SUCCESS,
    DELETE_SECTION_FAIL,
    FETCH_AVAILABLE_FIELDS_REQUEST,
    FETCH_AVAILABLE_FIELDS_SUCCESS,
    FETCH_AVAILABLE_FIELDS_FAIL,
} from '../actions/sectionActions';

const initialState = {
    list: [],
    availableFields: [],
    loading: false,
    error: null,
};

const sectionReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SECTIONS_REQUEST:
        case SAVE_SECTION_REQUEST:
        case DELETE_SECTION_REQUEST:
        case FETCH_AVAILABLE_FIELDS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_SECTIONS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };

        case SAVE_SECTION_SUCCESS:
            const exists = state.list.find(s => s.id === action.payload.id);
            return {
                ...state,
                list: exists 
                    ? state.list.map(s => s.id === action.payload.id ? action.payload : s)
                    : [...state.list, action.payload],
                loading: false,
            };

        case DELETE_SECTION_SUCCESS:
            return {
                ...state,
                list: state.list.filter(s => s.id !== action.payload),
                loading: false,
            };

        case FETCH_AVAILABLE_FIELDS_SUCCESS:
            return {
                ...state,
                availableFields: action.payload,
                loading: false,
            };

        case FETCH_SECTIONS_FAIL:
        case SAVE_SECTION_FAIL:
        case DELETE_SECTION_FAIL:
        case FETCH_AVAILABLE_FIELDS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default sectionReducer;
